import { cn, tv } from '@pcln/horizon'
import type { PackageFormTripType } from '../types'

const packagesFormSlots = {
  gridContainer: 'grid grid-cols-1 gap-3 items-center mx-auto',
  radioButtons: 'text-nowrap [grid-area:options]',
  originInput: '[grid-area:origin]',
  destinationInput: '[grid-area:destination]',
  timelineInput: '**:translate-y-0 [grid-area:timeline]',
  passengersInput: '**:translate-y-0 [grid-area:passengers]',
  advancedSearchSlot: '[grid-area:advanced] flex items-center gap-2 py-2',
  checkBoxSlot: '[grid-area:checkbox] pt-2',
  partStaySlot: '**:translate-y-0 [grid-area:partStay]',
  carPickupSlot: [
    '[grid-area:carPickup]',
    'grid gap-3 grid-cols-2 sm:grid-cols-4',
    "[grid-template-areas:'city_city'_'pickupDate_pickupTime'_'dropoffDate_dropoffTime']",
    "sm:[grid-template-areas:'city_city_city_city'_'pickupDate_pickupTime_dropoffDate_dropoffTime']"
  ]
}

const packagesTypeVariants = {
  hotelWithFlight: {
    gridContainer: [
      'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'group_group_group_group_group']"
    ],
    carPickupSlot:
      "lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr] lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  },
  hotelWithFlightPartStay: {
    gridContainer: [
      'sm:grid-cols-6 lg:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'partStay'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_partStay_partStay_partStay'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_destination_destination_timeline_timeline'_'partStay_partStay_passengers_passengers_submit_submit'_'group_group_group_group_group_group']"
    ],
    carPickupSlot:
      "lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr] lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  },
  hotelWithFlightWithCar: {
    gridContainer: [
      'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'group_group_group_group_group']"
    ],
    carPickupSlot:
      "lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr] lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  },
  hotelWithFlightWithCarPartStay: {
    gridContainer: [
      'sm:grid-cols-6 lg:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'partStay'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_partStay_partStay_partStay'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_destination_destination_timeline_timeline'_'partStay_partStay_passengers_passengers_submit_submit'_'group_group_group_group_group_group']"
    ],
    carPickupSlot:
      "lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr] lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  },
  flightWithCar: {
    gridContainer: [
      'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_max-content]',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options'_'origin_destination_timeline_passengers_submit'_'group_group_group_group_group']"
    ],
    carPickupSlot:
      "lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr] lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  },
  hotelWithCar: {
    gridContainer: [
      'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_max-content]',
      "[grid-template-areas:'options'_'destination'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_destination_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options'_'destination_timeline_passengers_submit'_'group_group_group_group']"
    ],
    carPickupSlot:
      "lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr] lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  },
  hotelWithCarPickupElsewhere: {
    gridContainer: [
      'sm:grid-cols-6 lg:grid-cols-[1fr_1fr_1fr_1fr_1fr_.25fr]',
      "[grid-template-areas:'options'_'destination'_'timeline'_'passengers'_'checkbox'_'carPickup'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_destination_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'carPickup_carPickup_carPickup_carPickup_carPickup_carPickup'_'submit_submit_submit_submit_submit_submit']",
      "lg:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_timeline_timeline_passengers_passengers'_'carPickup_carPickup_carPickup_carPickup_carPickup_submit'_'group_group_group_group_group_group']"
    ],
    carPickupSlot:
      "lg:grid-cols-[1.5fr_1fr_.75fr_1fr_.75fr] lg:[grid-template-areas:'city_pickupDate_pickupTime_dropoffDate_dropoffTime']"
  },
  // Compact variants - maintain sm layout through lg for homepage hero
  // Layout: options | origin+destination | advanced | timeline+passengers | checkbox | submit
  hotelWithFlightCompact: {
    gridContainer: [
      'sm:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']"
    ],
    carPickupSlot: ''
  },
  hotelWithFlightPartStayCompact: {
    gridContainer: [
      'sm:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'partStay'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_partStay_partStay_partStay'_'submit_submit_submit_submit_submit_submit']"
    ],
    carPickupSlot: ''
  },
  hotelWithFlightWithCarCompact: {
    gridContainer: [
      'sm:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']"
    ],
    carPickupSlot: ''
  },
  hotelWithFlightWithCarPartStayCompact: {
    gridContainer: [
      'sm:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'checkbox'_'partStay'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_partStay_partStay_partStay'_'submit_submit_submit_submit_submit_submit']"
    ],
    carPickupSlot: ''
  },
  flightWithCarCompact: {
    gridContainer: [
      'sm:grid-cols-6',
      "[grid-template-areas:'options'_'origin'_'destination'_'advanced'_'timeline'_'passengers'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'origin_origin_origin_destination_destination_destination'_'advanced_advanced_advanced_advanced_advanced_advanced'_'timeline_timeline_timeline_passengers_passengers_passengers'_'submit_submit_submit_submit_submit_submit']"
    ],
    carPickupSlot: ''
  },
  hotelWithCarCompact: {
    gridContainer: [
      'sm:grid-cols-6',
      "[grid-template-areas:'options'_'destination'_'timeline'_'passengers'_'checkbox'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_destination_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'submit_submit_submit_submit_submit_submit']"
    ],
    carPickupSlot: ''
  },
  hotelWithCarPickupElsewhereCompact: {
    gridContainer: [
      'sm:grid-cols-6',
      "[grid-template-areas:'options'_'destination'_'timeline'_'passengers'_'checkbox'_'carPickup'_'submit']",
      "sm:[grid-template-areas:'options_options_options_options_options_options'_'destination_destination_destination_destination_destination_destination'_'timeline_timeline_timeline_passengers_passengers_passengers'_'checkbox_checkbox_checkbox_checkbox_checkbox_checkbox'_'carPickup_carPickup_carPickup_carPickup_carPickup_carPickup'_'submit_submit_submit_submit_submit_submit']"
    ],
    carPickupSlot: ''
  }
}

type PackagesTypeVariants = keyof typeof packagesTypeVariants

export const horizonPackagesForm = tv({
  slots: packagesFormSlots,
  variants: {
    packagesType: packagesTypeVariants
  }
})

const getPackagesTypeVariant = (
  packagesType: PackageFormTripType,
  isHotelPartialStay: boolean,
  isCarPickupElsewhere: boolean,
  useCompactLayout = false
): PackagesTypeVariants => {
  if (useCompactLayout) {
    if (packagesType === 'STAY:FLY:DRIVE') {
      if (isHotelPartialStay) {
        return 'hotelWithFlightWithCarPartStayCompact'
      }
      return 'hotelWithFlightWithCarCompact'
    }
    if (packagesType === 'FLY:DRIVE') {
      return 'flightWithCarCompact'
    }
    if (packagesType === 'STAY:DRIVE') {
      if (isCarPickupElsewhere) {
        return 'hotelWithCarPickupElsewhereCompact'
      }
      return 'hotelWithCarCompact'
    }
    if (isHotelPartialStay) {
      return 'hotelWithFlightPartStayCompact'
    }
    return 'hotelWithFlightCompact'
  }

  if (packagesType === 'STAY:FLY:DRIVE') {
    if (isHotelPartialStay) {
      return 'hotelWithFlightWithCarPartStay'
    }
    return 'hotelWithFlightWithCar'
  }
  if (packagesType === 'FLY:DRIVE') {
    return 'flightWithCar'
  }
  if (packagesType === 'STAY:DRIVE') {
    if (isCarPickupElsewhere) {
      return 'hotelWithCarPickupElsewhere'
    }
    return 'hotelWithCar'
  }
  if (isHotelPartialStay) {
    return 'hotelWithFlightPartStay'
  }
  return 'hotelWithFlight'
}
export const getGridContainerClass = (
  packagesType: PackageFormTripType,
  isHotelPartialStay: boolean,
  isCarPickupElsewhere: boolean,
  useCompactLayout = false
) => {
  const packagesTypeVariant = getPackagesTypeVariant(
    packagesType,
    isHotelPartialStay,
    isCarPickupElsewhere,
    useCompactLayout
  )
  const styles = horizonPackagesForm({ packagesType: packagesTypeVariant })

  return cn(styles.gridContainer())
}

export const getCarPickupSlotClass = (
  packagesType: PackageFormTripType,
  isHotelPartialStay: boolean,
  isCarPickupElsewhere: boolean,
  useCompactLayout = false
) => {
  const packagesTypeVariant = getPackagesTypeVariant(
    packagesType,
    isHotelPartialStay,
    isCarPickupElsewhere,
    useCompactLayout
  )
  const styles = horizonPackagesForm({ packagesType: packagesTypeVariant })

  return cn(styles.carPickupSlot())
}
